import React from "react";

/**
 * ProjectCard renders a single project: a gradient header, title,
 * description, tech-stack tags, and links out to the live repo/demo.
 * Used on both the Home page (preview grid) and the full Projects page.
 */
const ProjectCard = ({ project }) => {
  return (
    <article className="project-card" style={{ borderRadius: "0.75rem", overflow: "hidden" }}>
      <div style={{ height: 192, background: project.gradient }} />
      <div style={{ padding: "1.5rem" }}>
        <h3
          style={{
            color: "var(--text-primary)",
            fontWeight: 600,
            fontSize: "1.25rem",
            marginBottom: "0.75rem",
          }}
        >
          {project.title}
        </h3>
        <p
          style={{
            color: "var(--text-muted)",
            fontSize: "0.875rem",
            lineHeight: 1.6,
            marginBottom: "1rem",
          }}
        >
          {project.description}
        </p>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "0.5rem",
            marginBottom: "1rem",
          }}
        >
          {project.tags.map((tag) => (
            <span key={tag} className="tag">
              {tag}
            </span>
          ))}
        </div>
        <div style={{ display: "flex", gap: "0.75rem" }}>
          <a
            href={project.githubUrl || "https://github.com/ksr2005"}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: "0.5rem",
              borderRadius: "0.5rem",
              color: "var(--accent)",
            }}
            aria-label={`${project.title} GitHub repository`}
          >
            <svg
              style={{ width: 20, height: 20 }}
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" />
            </svg>
          </a>
          <a
            href={project.liveUrl || "#"}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: "0.5rem",
              borderRadius: "0.5rem",
              color: "var(--accent)",
            }}
            aria-label={`${project.title} live demo`}
          >
            <svg
              style={{ width: 20, height: 20 }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              />
            </svg>
          </a>
        </div>
      </div>
    </article>
  );
};

export default ProjectCard;
